import { createFileRoute, notFound } from "@tanstack/react-router";

import { NotFoundPage } from "@/components/landing/LandingNotFound";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";
import ProxyCheckerPage from "./proxy-checker/-components/ProxyCheckerPage";
import { proxyCheckerPageCms } from "./proxy-checker/-components/proxyCheckerSource";

/**
 * The public Proxy Tester (R-298): the dashboard's tester, open without an
 * account, and the sections around it. Prerendered from the CMS as every
 * marketing page is; the tester itself runs in the browser.
 *
 * Not `/proxy-tester`, which is the dashboard's own tester and where a new
 * account lands after signing up from here. A sibling of `_app` so the
 * dashboard's guard never sees an anonymous reader here.
 */
export const Route = createFileRoute("/proxy-checker")({
  loader: async () => {
    const content = await proxyCheckerPageCms();
    if (!content) {
      throw notFound();
    }
    return content;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: ProxyCheckerRoute,
  notFoundComponent: NotFoundPage,
});

function ProxyCheckerRoute() {
  return <ProxyCheckerPage content={Route.useLoaderData()} />;
}
